import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { get } from 'lodash';
import './ThemeDesignSettings.styles.less';

const ThemeDesignSettings = ({ themeGroupTitle, wedding, theme }) => {
  const themeThumbnail = get(theme, 'preview_images[0]');

  return (
    <React.Fragment>
      <div className="visible-xs visible-sm">
        <div className="design-container row">
          <div className="theme-header">
            <i className="zolaicon-public zolaicon-website-design icon" />
            <span className="theme-heading">Design:</span><p className="theme-name">{themeGroupTitle}</p>
            <Link to="/wedding/manage/website/designs" className="theme-link text-button">Change</Link>
          </div>
        </div>
        <div className="design-container row">
          <div className="theme-header">
            <Link to={`/wedding/${wedding.slug}`} target="_blank">
              <i className="zolaicon-public zolaicon-preview-icon icon" />
              <span className="theme-heading">Preview</span>
            </Link>
          </div>
        </div>
      </div>
      <div className="visible-md visible-lg">
        <div className="mpr-theme-container">
          <div className="mpr-theme-group">
            <div className="mpr-theme-name--desktop">{themeGroupTitle}</div>
            <div>
              <Link to="/wedding/manage/website/designs" className="mpr-theme-link--desktop">Change Design ›</Link>
            </div>
            <div>
              <Link to={`/wedding/${wedding.slug}`} target="_blank" className="btn btn-secondary mpr-preview--desktop">
              Preview Website
              </Link>
            </div>
          </div>
          {themeThumbnail && <img className="mpr-theme-thumbnail" src={themeThumbnail} alt="Design Theme Thumbnail" />}
        </div>
      </div>
    </React.Fragment>
  );
};


ThemeDesignSettings.propTypes = {
  themeGroupTitle: PropTypes.string,
  wedding: PropTypes.shape({}),
  theme: PropTypes.shape({})
};

export default ThemeDesignSettings;



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/DropDownForms/ThemeDesignSettings/ThemeDesignSettings.jsx